export default class Keys {
    static JWT_TOKEN = "DeluxeJwtToken";
    static ADMIN_TOKEN = "DeluxeAdminToken";
    static USER_DATA = "DeluxeUserData";
    static USER_CART = "DeluxeUserCart";
    static USER_FAVORITE = "DeluxeUserFavorite";
    static USER_RECENTLY = "DeluxeUserRecently";
}
